import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { playOrigin } from '@/config'

interface PlayLinkProps {
  /** App path on the game host, e.g. "/register". */
  path: string
  className?: string
  children: ReactNode
}

/**
 * Link from the public vitrine (apex `corsalia.net`) to the game host
 * (`play.corsalia.net`). In prod (VITE_PLAY_ORIGIN set) it renders a real
 * cross-host `<a href>`; in dev (unset) it renders a react-router `<Link>` so
 * local navigation stays client-side and same-host — i.e. it "just works".
 */
export function PlayLink({ path, className, children }: PlayLinkProps) {
  const origin = playOrigin()
  if (origin) {
    return (
      <a href={`${origin}${path}`} className={className}>
        {children}
      </a>
    )
  }
  return (
    <Link to={path} className={className}>
      {children}
    </Link>
  )
}
